/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e,n,t,r={passive:!0}){return e.addEventListener(n,t,r),()=>e.removeEventListener(n,t)}export{e as addDomEvent};
//# sourceMappingURL=add-dom-event.js.map
